import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useState } from 'react';
import { getSelectionListWidgetStyles } from './SelectionListWidgetStyles';
import { View } from 'react-native';
import { Button, Callout, Input, getTestId, isValidObject, tokens } from '@airtel/air-design-system';
import { LinkListItemWidget } from '../link-list-item-widget';
import { OtpWidget } from '../otp-widget';
import { OfferContextualStripWidget } from '../offer-contextual-strip-widget';
export var SelectionListWidgetComponent = props => {
  var id = props.id,
    linkListItemProps = props.linkListItemProps,
    offerStripProps = props.offerStripProps,
    _props$calloutProps = props.calloutProps,
    calloutProps = _props$calloutProps === void 0 ? [] : _props$calloutProps,
    _props$primaryCallout = props.primaryCalloutProps,
    primaryCalloutProps = _props$primaryCallout === void 0 ? [] : _props$primaryCallout,
    _props$secondaryCallo = props.secondaryCalloutProps,
    secondaryCalloutProps = _props$secondaryCallo === void 0 ? [] : _props$secondaryCallo,
    _props$bottomCalloutP = props.bottomCalloutProps,
    bottomCalloutProps = _props$bottomCalloutP === void 0 ? [] : _props$bottomCalloutP,
    _props$buttonProps = props.buttonProps,
    buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps,
    _props$topSelectionCa = props.topSelectionCalloutProps,
    topSelectionCalloutProps = _props$topSelectionCa === void 0 ? [] : _props$topSelectionCa,
    _props$shouldEnableBu = props.shouldEnableButton,
    shouldEnableButton = _props$shouldEnableBu === void 0 ? true : _props$shouldEnableBu,
    _props$secondaryButto = props.secondaryButtonProps,
    secondaryButtonProps = _props$secondaryButto === void 0 ? {} : _props$secondaryButto,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
    isSelected = props.isSelected,
    onButtonPressMetaData = props.onButtonPressMetaData,
    secondaryButtonPressMetaData = props.secondaryButtonPressMetaData,
    onLinkListItemPress = props.onLinkListItemPress,
    _onUserAction = props.onUserAction,
    style = props.style,
    _props$otpProps = props.otpProps,
    otpProps = _props$otpProps === void 0 ? {} : _props$otpProps,
    isTextSecure = props.isTextSecure,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SelectionListWidget' : _props$testID,
    _props$selectedAccess = props.selectedAccessibilityProps,
    selectedAccessibilityProps = _props$selectedAccess === void 0 ? {} : _props$selectedAccess,
    _props$unselectedAcce = props.unselectedAccessibilityProps,
    unselectedAccessibilityProps = _props$unselectedAcce === void 0 ? {} : _props$unselectedAcce,
    _props$isCurrentItemV = props.isCurrentItemVisible,
    isCurrentItemVisible = _props$isCurrentItemV === void 0 ? true : _props$isCurrentItemV;
  var selectionListWidgetStyles = getSelectionListWidgetStyles(props);
  var isInputPropsValid = isValidObject(inputProps);
  var _useState = useState(isSelected),
    isItemSelected = _useState[0],
    handleItemSelection = _useState[1];
  var _useState2 = useState(isInputPropsValid),
    isButtonDisabled = _useState2[0],
    handleButtonDisable = _useState2[1];
  var validButtonProps = isValidObject(buttonProps);
  var validOTPProps = isValidObject(otpProps);
  var validOfferStripProps = isValidObject(offerStripProps);
  var _useState3 = useState(''),
    cvvData = _useState3[0],
    handleCVVData = _useState3[1];
  var _useState4 = useState(inputProps.appendItems),
    appendItems = _useState4[0],
    setAppendItems = _useState4[1];
  var _useState5 = useState(isTextSecure),
    isSecureTextEntry = _useState5[0],
    setIsSecureTextEntry = _useState5[1];
  var userActionExtraData = {
    cvv: cvvData
  };
  var handleSelection = () => {
    if (!isItemSelected) {
      if (onLinkListItemPress) {
        onLinkListItemPress === null || onLinkListItemPress === void 0 ? void 0 : onLinkListItemPress(id);
      } else {
        handleItemSelection(true);
      }
    }
  };
  var onButtonPressed = (buttonPressMetaData, buttonProps) => {
    executeUserActionForButtonPress(buttonPressMetaData, buttonProps);
    handleButtonDisable(true);
    setTimeout(() => {
      handleButtonDisable(false);
    }, 1000);
  };
  var executeUserActionForButtonPress = (buttonPressMetaData, buttonProps) => {
    buttonPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, buttonPressMetaData), {
      buttonProps,
      linkListItemProps,
      userActionExtraData
    }));
  };
  var primaryButtonOnPress = useCallback(() => {
    onButtonPressed(onButtonPressMetaData, buttonProps);
  }, [onButtonPressed, onButtonPressMetaData, buttonProps]);
  var secondaryButtonOnPress = useCallback(() => {
    executeUserActionForButtonPress(secondaryButtonPressMetaData, secondaryButtonProps);
  }, [executeUserActionForButtonPress, secondaryButtonPressMetaData, secondaryButtonProps]);
  useEffect(() => {
    handleItemSelection(isSelected);
  }, [isSelected]);
  useEffect(() => {
    inputChangeHandler('');
  }, [isItemSelected]);
  var inputChangeHandler = data => {
    var _a;
    handleCVVData(data);
    var validationRegex = inputProps === null || inputProps === void 0 ? void 0 : inputProps.validationRegex;
    if (!!validationRegex && (validationRegex === null || validationRegex === void 0 ? void 0 : validationRegex.length) > 0) {
      validateRegex(data, validationRegex);
    } else {
      if (!(inputProps === null || inputProps === void 0 ? void 0 : inputProps.maxLength) || (inputProps === null || inputProps === void 0 ? void 0 : inputProps.maxLength) == ((_a = data === null || data === void 0 ? void 0 : data.toString()) === null || _a === void 0 ? void 0 : _a.length)) handleButtonDisable(false);else handleButtonDisable(true);
    }
    (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChangeText) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, inputProps.onChangeText), Object.assign(Object.assign({}, props), {
      value: data
    })));
  };
  var validateRegex = (text, regex) => {
    var validInput = text === null || text === void 0 ? void 0 : text.match(new RegExp(regex));
    if (validInput && (validInput === null || validInput === void 0 ? void 0 : validInput.length) > 0) {
      handleButtonDisable(false);
    } else {
      handleButtonDisable(true);
    }
  };
  var hintActionOnPressFunc = () => {
    (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onHintActionPressHandler) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, inputProps.onHintActionPressHandler), props));
  };
  var inputFieldOnPress = () => {
    (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, inputProps.onFocus), props));
  };
  var onAppendItemPress = () => {
    appendItems.onPress && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, appendItems.onPress), Object.assign(Object.assign({}, props), {
      iconName: isSecureTextEntry ? 'ShowButtonIcon' : 'HideButtonIcon'
    })));
    if (isSecureTextEntry) {
      setAppendItems(prevStateObj => Object.assign(Object.assign({}, prevStateObj), {
        prefixIcon: Object.assign(Object.assign({}, prevStateObj.prefixIcon), {
          iconName: 'HideButtonIcon'
        })
      }));
    } else {
      setAppendItems(prevStateObj => Object.assign(Object.assign({}, prevStateObj), {
        prefixIcon: Object.assign(Object.assign({}, prevStateObj.prefixIcon), {
          iconName: 'ShowButtonIcon'
        })
      }));
    }
    setIsSecureTextEntry(!isSecureTextEntry);
  };
  var handleCalloutPressAndDismiss = callBackHandler => {
    isValidObject(callBackHandler) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, callBackHandler), props));
  };
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: style
  }, {
    children: [linkListItemProps && Object.keys(linkListItemProps).length > 0 && _jsx(LinkListItemWidget, Object.assign({
      id: id,
      isCurrentItemVisible: isCurrentItemVisible
    }, getTestId(testID, 'linkListItemWidget'), linkListItemProps, {
      onPress: Object.assign(Object.assign({
        id: 'onPress'
      }, linkListItemProps.onPress), props),
      selected: isItemSelected,
      actionTypeOnPress: handleSelection,
      onUserAction: (data, extraData) => {
        if ((data === null || data === void 0 ? void 0 : data.id) === 'onPress') {
          handleSelection();
        } else {
          _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(data, extraData);
        }
      },
      onPressHandler: handleSelection,
      actionTypeProps: Object.assign({
        accessibilityProps: isItemSelected ? selectedAccessibilityProps : unselectedAccessibilityProps
      }, linkListItemProps.actionTypeProps)
    })), _jsxs(View, Object.assign({
      style: selectionListWidgetStyles.content
    }, {
      children: [isItemSelected && (topSelectionCalloutProps === null || topSelectionCalloutProps === void 0 ? void 0 : topSelectionCalloutProps.length) > 0 && topSelectionCalloutProps.map((TopSelectionCalloutProp, index) => {
        return _jsx(Fragment, {
          children: isValidObject(TopSelectionCalloutProp) && _jsx(Callout, Object.assign({
            style: selectionListWidgetStyles.callout
          }, TopSelectionCalloutProp))
        }, "calloutItem-" + index);
      }), validOfferStripProps && _jsx(OfferContextualStripWidget, Object.assign({}, offerStripProps, {
        style: selectionListWidgetStyles.callout
      }, getTestId(testID, 'offerStrip'), {
        onUserAction: _onUserAction
      })), (primaryCalloutProps === null || primaryCalloutProps === void 0 ? void 0 : primaryCalloutProps.length) > 0 && primaryCalloutProps.map(primaryCalloutProp => {
        var _primaryCalloutProp$s = primaryCalloutProp.showCallout,
          showCallout = _primaryCalloutProp$s === void 0 ? true : _primaryCalloutProp$s;
        return _jsx(_Fragment, {
          children: Object.keys(primaryCalloutProp).length > 0 && showCallout && _jsx(Callout, Object.assign({
            style: selectionListWidgetStyles.callout
          }, primaryCalloutProp, {
            onCtaPress: () => handleCalloutPressAndDismiss(primaryCalloutProp === null || primaryCalloutProp === void 0 ? void 0 : primaryCalloutProp.onCtaPress),
            onDismissHandler: () => {
              handleCalloutPressAndDismiss(primaryCalloutProp === null || primaryCalloutProp === void 0 ? void 0 : primaryCalloutProp.onDismissHandler);
            }
          }))
        });
      }), (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.length) > 0 && calloutProps.map(calloutProp => {
        var _calloutProp$showCall = calloutProp.showCallout,
          showCallout = _calloutProp$showCall === void 0 ? true : _calloutProp$showCall;
        return _jsx(_Fragment, {
          children: Object.keys(calloutProp).length > 0 && showCallout && _jsx(Callout, Object.assign({
            style: selectionListWidgetStyles.callout
          }, calloutProp, {
            onCtaPress: () => handleCalloutPressAndDismiss(calloutProp === null || calloutProp === void 0 ? void 0 : calloutProp.onCtaPress),
            onDismissHandler: () => {
              handleCalloutPressAndDismiss(calloutProp === null || calloutProp === void 0 ? void 0 : calloutProp.onDismissHandler);
            }
          }))
        });
      }), (secondaryCalloutProps === null || secondaryCalloutProps === void 0 ? void 0 : secondaryCalloutProps.length) > 0 && secondaryCalloutProps.map(secondaryCalloutProp => {
        var _secondaryCalloutProp = secondaryCalloutProp.showCallout,
          showCallout = _secondaryCalloutProp === void 0 ? true : _secondaryCalloutProp;
        return _jsx(_Fragment, {
          children: Object.keys(secondaryCalloutProp).length > 0 && showCallout && _jsx(Callout, Object.assign({
            style: selectionListWidgetStyles.callout
          }, secondaryCalloutProp, {
            onCtaPress: () => handleCalloutPressAndDismiss(secondaryCalloutProp === null || secondaryCalloutProp === void 0 ? void 0 : secondaryCalloutProp.onCtaPress),
            onDismissHandler: () => {
              handleCalloutPressAndDismiss(secondaryCalloutProp === null || secondaryCalloutProp === void 0 ? void 0 : secondaryCalloutProp.onDismissHandler);
            }
          }))
        });
      }), isItemSelected && (validButtonProps || isInputPropsValid || validOTPProps) && _jsxs(View, Object.assign({
        style: [selectionListWidgetStyles.buttonAndInputGroup, validOTPProps && {
          flexDirection: 'column'
        }]
      }, {
        children: [isValidObject(inputProps) && _jsx(Input, Object.assign({}, inputProps, {
          containerStyle: selectionListWidgetStyles.input
        }, getTestId(testID, 'button'), {
          onChangeText: inputChangeHandler,
          onHintActionPressHandler: hintActionOnPressFunc,
          onFocus: inputFieldOnPress,
          secureTextEntry: isSecureTextEntry,
          appendItems: Object.assign(Object.assign({}, appendItems), {
            onPress: onAppendItemPress
          })
        })), isValidObject(buttonProps) && _jsx(View, Object.assign({
          style: selectionListWidgetStyles.button
        }, {
          children: _jsx(Button, Object.assign({}, buttonProps, getTestId(testID, 'button'), {
            version: "variable-width",
            onPress: primaryButtonOnPress,
            disabled: !(shouldEnableButton && !isButtonDisabled)
          }))
        })), isValidObject(otpProps) && _jsx(OtpWidgetWrapper, Object.assign({}, otpProps, {
          onUserAction: _onUserAction
        }))]
      })), isItemSelected && (bottomCalloutProps === null || bottomCalloutProps === void 0 ? void 0 : bottomCalloutProps.length) > 0 && bottomCalloutProps.map(bottomCalloutProps => {
        return _jsx(_Fragment, {
          children: Object.keys(bottomCalloutProps).length > 0 && _jsx(Callout, Object.assign({
            style: selectionListWidgetStyles.callout
          }, bottomCalloutProps))
        });
      }), isValidObject(secondaryButtonProps) && _jsx(View, {
        children: _jsx(Button, Object.assign({}, secondaryButtonProps, {
          version: "variable-width",
          onPress: secondaryButtonOnPress
        }))
      })]
    }))]
  }));
};
SelectionListWidgetComponent.genericRendererKey = 'AirSelectionListWidget';
var OtpWidgetWrapper = props => {
  return _jsx(View, {
    children: _jsx(OtpWidget, Object.assign({}, props, {
      secondaryCtaProps: Object.assign(Object.assign({}, props === null || props === void 0 ? void 0 : props.secondaryCtaProps), {
        buttonType: 'tertiary',
        version: 'fixed-padding',
        style: {
          marginTop: tokens.spacing.SPACING_8
        }
      }),
      primaryCtaProps: Object.assign(Object.assign({}, props === null || props === void 0 ? void 0 : props.primaryCtaProps), {
        buttonType: 'primary'
      }),
      onUserAction: props === null || props === void 0 ? void 0 : props.onUserAction
    }))
  });
};